/**
 * Canonical paths of the organization pages tree
 * (see `src/pages/organization`).
 *
 * The organization home is mounted both at the root path `/` and at
 * `/organization` during the gradual `src/views` → `src/pages`
 * migration, so existing in-app links keep pointing at `/` for now.
 */
export const ORGANIZATION_PATHS = {
    /** Organization home (also mounted at the root path `/`). */
    home: '/organization',
    /** Organization picker page. */
    select: '/organization/select',
    /** Organization settings; redirects to the default tab subview. */
    settings: '/organization/settings',
    /** Organization info settings subview. */
    settingsInfo: '/organization/settings/info',
    /** User administration settings subview. */
    settingsUsers: '/organization/settings/users',
} as const;
